import { generatePath } from 'react-router-dom';

import { ROUTES } from '#client/manifest';

import { processMenu } from '../utils/menu';

/**
 * Get the money menu items.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 * }} params
 * @returns {Array}
 */
function getMoneyMenuItems({ businessEntityUuid, entitlements }) {
  // Includes money pro and money essential order task types.
  const hasExpenseTracking = entitlements.has('expense_tracking');
  // Includes money pro order task type.
  const hasAccounting = entitlements.has('accounting');

  return [
    {
      order: 10,
      title: 'Overview',
      path: generatePath(ROUTES.moneyLandingPage, { businessEntityUuid })
    },
    {
      order: 20,
      show: hasAccounting || hasExpenseTracking,
      title: 'Expenses',
      path: generatePath(ROUTES.moneyPages, { businessEntityUuid, page: 'expenses' })
    },
    {
      order: 30,
      show: hasAccounting,
      title: 'Invoices',
      path: generatePath(ROUTES.moneyPages, { businessEntityUuid, page: 'invoices' })
    },
    {
      order: 40,
      show: hasAccounting,
      title: 'Time & Task',
      path: generatePath(ROUTES.moneyPages, { businessEntityUuid, page: 'time-dash' })
    },
    {
      order: 50,
      show: hasAccounting,
      title: 'Income',
      path: generatePath(ROUTES.moneyPages, { businessEntityUuid, page: 'income' })
    },
    {
      order: 60,
      show: hasAccounting,
      title: 'Mileage Tracking',
      path: generatePath(ROUTES.moneyPages, { businessEntityUuid, page: 'mileage' })
    },
    {
      order: 70,
      show: hasAccounting,
      title: 'Taxes',
      path: generatePath(ROUTES.moneyPages, { businessEntityUuid, page: 'taxes' })
    },
    {
      order: 80,
      show: hasAccounting,
      title: 'Reports',
      path: generatePath(ROUTES.moneyPages, { businessEntityUuid, page: 'reports' })
    }
  ];
}

/**
 * Get the money studio menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getMoneyMenu({ businessEntityUuid, entitlements, order }) {
  return processMenu({
    title: 'ZenBusiness Money',
    icon: 'money-fill.svg',
    links: getMoneyMenuItems({ businessEntityUuid, entitlements }),
    order
  });
}
